export default "__VITE_ASSET__D1cv5wwS__"